import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { apiHandler } from "../../api";
import { endpoint } from "../../api/endpoint";

const useDashBoard = () => {
  const { authData } = useSelector((state) => state.loginSlice);
  const [dashboardData, setDashboardData] = useState(null);
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();

  const fetchAnalytics = async () => {
    try {
      setLoader(true);
      const response = await apiHandler({
        url: endpoint.GET_ANALYTICS,
        method: "GET",
        authToken: authData,
        dispatch,
      });

      if (response.data.statusCode === 200) {
        setDashboardData(response.data.data.dashboardData);
      }
    } catch (error) {

    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchAnalytics();
  }, []);

  const serviceChartOptions = useMemo(
    () => ({
      chart: {
        id: "service-bar-chart",
        toolbar: { show: false },
        // Adding animations: false can sometimes help with initial render crashes
      },
      xaxis: {
        // Ensure this is ALWAYS an array, even if data is null
        categories:
          dashboardData?.service_based_tenant_count?.map(
            (s) => s.service_name
          ) || [],
      },
      colors: ["#4F46E5"],
      plotOptions: { bar: { borderRadius: 6, columnWidth: "40%" } },
      dataLabels: { enabled: false },
    }),
    [dashboardData]
  ); // Only recalculate when dashboardData changes

  const serviceChartSeries = useMemo(
    () => [
      {
        name: "Global Tenants",
        data:
          dashboardData?.service_based_tenant_count?.map(
            (s) => s.tenant_count
          ) || [],
      },
    ],
    [dashboardData]
  );

  const providerChartSeries = useMemo(
    () => [
      {
        name: "Provider Tenants",
        data:
          dashboardData?.futuresoft_MSN_Provider_overview?.service_based_tenant_count?.map(
            (s) => s.tenant_count
          ) || [],
      },
    ],
    [dashboardData]
  );

  return {
    loader,
    dashboardData,
    serviceChartOptions,
    serviceChartSeries,
    providerChartSeries,
  };
};

export default useDashBoard;
